import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import PageNotFoundIcon from 'src/assets/img/page-not-found.svg?react';
import { links } from 'src/components/chrome';
import {
  TemplateContainer,
  ActionButtonContainer,
  ActionButton,
  MessageLayout,
} from './commons';

type NotFoundErrorNoticeProps = {
  children?: never;
};

const LegacyNotFoundErrorNotice = (_: NotFoundErrorNoticeProps) => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate(links.logout);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <TemplateContainer>
      <MessageLayout
        headerTitle="Page not found"
        headerImage={<PageNotFoundIcon/>}
        message="The page you are looking for doesn't exist or has been moved."
        footer={(
          <ActionButtonContainer>
            <ActionButton
              variant="outlined"
              color="secondary"
              size="large"
              onClick={handleGoToLogin}>
              Go to log in
            </ActionButton>
            <ActionButton
              variant="contained"
              size="large"
              onClick={handleGoBack}>
              <ArrowBack/>
              Go back
            </ActionButton>
          </ActionButtonContainer>
        )}/>
    </TemplateContainer>
  );
};

export default LegacyNotFoundErrorNotice;
